module.exports = __webpack_public_path__ + "img/logo-full-white.a0db2dde.svg";